import useBiometrics from './useBiometrics'

export default useBiometrics
